<template>
    <div class="info-tooltip">
        <div
            class="info-icon"
            @mouseover="onMouseOver"
            @mouseout="onMouseOut"
        >
            <svg-inline
                src="info_icon"
            />
        </div>
        <div
            ref="content"
            class="tooltip-content"
        >
            <div class="definition">
                <div
                    v-for="(text, i) in definitionParagraphs"
                    :key="`definition-${i}`"
                    class="paragraph"
                >
                    {{ text }}
                </div>
            </div>
            <div class="link-to-health">
                <div
                    v-for="(text, i) in linkToHealthParagraphs"
                    :key="`link-to-health-${i}`"
                    class="paragraph"
                >
                    {{ text }}
                </div>
            </div>
            <div class="data-source">
                Data Source: {{ dataSource }}
            </div>
        </div>
    </div>
</template>

<script>
import SvgInline from '@/components/SvgInline.vue';

export default {
    components: {
        SvgInline
    },
    props: {
        definition: {
            type: String,
            required: true
        },
        linkToHealth: {
            type: String,
            required: true
        },
        dataSource: {
            type: String,
            required: true
        }
    },
    computed: {
        definitionParagraphs() {
            if (!this.definition) {
                return [];
            }
            // Hard-coded delimiter for paragraph splitting
            return this.definition.split('^^');
        },
        linkToHealthParagraphs() {
            if (!this.linkToHealth) {
                return [];
            }
            // Hard-coded delimiter for paragraph splitting
            return this.linkToHealth.split('^^');
        }
    },
    methods: {
        onMouseOver() {
            this.$refs.content.classList.add('visible');
        },
        onMouseOut() {
            this.$refs.content.classList.remove('visible');
        }
    }
};
</script>

<style lang="postcss" scoped>
.info-tooltip {
    @apply absolute right-0 top-0 text-2xl;
}

.info-tooltip .tooltip-content {
    display: none;
    @apply
        absolute
        top-0
        text-xs
        text-neutral-text
        ml-2
        bg-white
        p-3
        leading-none
        rounded-sm
        max-w-xl
        z-10
        pointer-events-none
        shadow-tooltip
        leading-relaxed;
    left: 100%;
    width: 250px;
}

@screen sm {
    .info-tooltip .tooltip-content { width: 300px; }
}

@screen md {
    .info-tooltip .tooltip-content { width: 340px; }
}

@screen lg {
    .info-tooltip .tooltip-content { width: 400px; }
}

@screen mobile {
    .info-tooltip .tooltip-content { left: -270px; }
}

.info-tooltip > div.info-icon {
    @apply cursor-pointer select-none text-neutral-info;
}

.info-tooltip .tooltip-content.visible {
    @apply block;
}

.tooltip-content .link-to-health {
    @apply italic text-primary-4 mt-1;
}

.tooltip-content .data-source {
    @apply italic text-neutral-label mt-1;
}

.paragraph:not(:first-child) {
    @apply mt-1;
}

.info-tooltip .svg-inline-container {
    height: 0.8em;
    width: 0.8em;
}

@screen lg {
    .info-tooltip .svg-inline-container {
        height: 1em;
        width: 1em;
    }
}
</style>

<style lang="postcss">
.info-tooltip .svg-inline {
    width: unset;
}
</style>
